import { useEffect } from "react";
import * as pickslipSlice from "sections/Pickems/PickSlip/pickslipSlice";
import { usePickemsContests } from "../v2/pickems/usePickemsContests";
import { useLivePickemsEntries } from "../v2/pickems/usePickemsEntries";

const usePickemsLobby = () => {
  useEffect(() => {
    pickslipSlice.updatePickslip({ contestId: null });
  }, []);

  const {
    contests,
    isLoading: contestsLoading,
    error: contestsError,
  } = usePickemsContests();
  const {
    entries,
    isLoading: entriesLoading,
    error: entriesError,
  } = useLivePickemsEntries();

  return {
    contests,
    entries,
    isLoading: contestsLoading || entriesLoading,
    error: contestsError || entriesError,
  } as const;
};

export default usePickemsLobby;
